// Using require() to import JS in TS files
var soundApi = require('./sound');
var MAIN_AUDIO_GROUP = 'mainaudio';
var PREVIEW_GROUP = 'preview';
/**
 * Handles playback of individual samples.
 */
var SamplePlayer = /** @class */ (function () {
    function SamplePlayer() {
        this.playingSamples = [];
        this.isPlaying = false;
        this.startPlayingAudioTime = -1;
        this.isInitialized = false;
        this.groupPath = '';
    }
    SamplePlayer.prototype.initialize = function (library) {
        var soundList = library.groups
            .map(function (group) {
            return group.folders.map(function (folder) {
                return folder.sounds.map(function (sound) {
                    return {
                        path: group.path + '/' + folder.path + '/' + sound.src,
                        restricted: sound.restricted,
                    };
                });
            });
        })
            .flat(2);
        soundApi.InitSound(soundList);
        this.groupPath = library.groups[0].path;
        this.isInitialized = true;
    };
    SamplePlayer.prototype.initialized = function () {
        return this.isInitialized;
    };
    SamplePlayer.prototype.startPlayback = function (sampleEventList) {
        if (!this.isInitialized) {
            console.warn('Sample player not initialized.');
            return;
        }
        this.stopPlayback();
        this.startPlayingAudioTime = soundApi.GetCurrentAudioTime();
        this.isPlaying = true;
        this.playSamples(sampleEventList);
        soundApi.StartPlayback();
    };
    SamplePlayer.prototype.previewSample = function (sampleId, onStop) {
        if (!this.isInitialized) {
            console.warn('Sample player not initialized.');
            return;
        }
        this.cancelPreviews();
        soundApi.PlaySound(this.groupPath + '/' + sampleId, PREVIEW_GROUP, 0, onStop);
    };
    SamplePlayer.prototype.previewSamples = function (events, onStop) {
        var _this = this;
        if (!this.isInitialized) {
            console.warn('Sample player not initialized.');
            return;
        }
        this.cancelPreviews();
        var counter = 0;
        var onStopWrapper = onStop
            ? function () {
                counter++;
                if (counter === events.length) {
                    onStop();
                }
            }
            : undefined;
        events.forEach(function (event) {
            soundApi.PlaySound(_this.groupPath + '/' + event.sampleId, PREVIEW_GROUP, soundApi.GetCurrentAudioTime() + event.offsetSeconds, onStopWrapper);
        });
    };
    SamplePlayer.prototype.playing = function () {
        return this.isPlaying;
    };
    SamplePlayer.prototype.getElapsedPlaybackTimeSeconds = function () {
        var currentAudioTime = soundApi.GetCurrentAudioTime();
        if (!this.isPlaying || currentAudioTime === null) {
            return -1;
        }
        return currentAudioTime - this.startPlayingAudioTime;
    };
    SamplePlayer.prototype.playSamples = function (sampleEvents) {
        if (!this.isInitialized) {
            console.warn('Sample player not initialized.');
            return;
        }
        if (!this.isPlaying) {
            return;
        }
        for (var _i = 0, sampleEvents_1 = sampleEvents; _i < sampleEvents_1.length; _i++) {
            var sampleEvent = sampleEvents_1[_i];
            var currentAudioTime = soundApi.GetCurrentAudioTime();
            var eventStart = this.startPlayingAudioTime + sampleEvent.offsetSeconds;
            // Triggered sounds might have a target play time that is very slightly in
            // the past, specificially when they use the currentTime passed (slightly
            // earlier) into the event handler code as the target play time.
            // To compensate for this delay, if the target play time is within a tenth of
            // a second of the current play time, then play it.
            // Note that we still don't play sounds older than that, because they might
            // have been scheduled for some time ago, and Web Audio will play a
            // sound immediately if its target time is in the past.
            // We have a similar, but smaller, grace period for non-triggered sounds,
            // since it might take a little time to start playing all the sounds in a
            // complex song.
            var delayCompensation = sampleEvent.triggered ? 0.1 : 0.05;
            if (eventStart >= currentAudioTime - delayCompensation) {
                var uniqueId = soundApi.PlaySound(this.groupPath + '/' + sampleEvent.sampleId, MAIN_AUDIO_GROUP, eventStart, null, false, sampleEvent.effects);
                this.playingSamples.push({
                    eventStart: eventStart,
                    uniqueId: uniqueId,
                });
            }
        }
    };
    SamplePlayer.prototype.stopPlayback = function () {
        soundApi.StopSound(MAIN_AUDIO_GROUP);
        soundApi.StopSound(PREVIEW_GROUP);
        this.playingSamples = [];
        this.isPlaying = false;
        this.startPlayingAudioTime = -1;
    };
    SamplePlayer.prototype.cancelPreviews = function () {
        soundApi.StopSound(PREVIEW_GROUP);
    };
    /**
     * Stops all samples that have not yet been played.
     */
    SamplePlayer.prototype.stopAllSamplesStillToPlay = function () {
        if (!this.isPlaying) {
            return;
        }
        for (var _i = 0, _a = this.playingSamples; _i < _a.length; _i++) {
            var sample = _a[_i];
            if (sample.eventStart > soundApi.GetCurrentAudioTime()) {
                soundApi.StopSoundByUniqueId(MAIN_AUDIO_GROUP, sample.uniqueId);
            }
        }
    };
    return SamplePlayer;
}());
export default SamplePlayer;
